
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"white"}}),_c('path',{attrs:{"d":"M12 0C5.37313 0 0 5.37313 0 12C0 18.6269 5.37313 24 12 24C18.6269 24 24 18.6269 24 12C24 5.37313 18.6269 0 12 0ZM11.9284 8.1194C12.9791 8.1194 13.8388 8.9791 13.8388 10.0299C13.8388 11.0806 12.9791 11.9403 11.9284 11.9403C10.8776 11.9403 10.0179 11.0806 10.0179 10.0299C10.0179 8.9791 10.8657 8.1194 11.9284 8.1194ZM13.1343 19.2358C12.8 19.4269 12.5493 19.5582 12.191 19.5582C11.8567 19.5582 11.606 19.4388 11.2836 19.2597C10.2448 18.6627 3.21194 15.0209 5.97015 5.49254C6.26866 6.65075 6.79403 9.08657 8.66866 11.1284C9.49254 12.1433 10.5313 12.9313 11.7254 13.4328C12.6687 13.8269 13.6716 14.0299 14.6866 14.0299C15.2478 14.0299 15.797 13.9701 16.3582 13.8507C17.1224 13.6836 17.8507 13.397 18.5313 13.0149C17.2537 16.991 13.9224 18.7821 13.1343 19.2358ZM18.8537 11.7731C18.0537 12.3701 17.1463 12.7761 16.1791 12.991C15.2119 13.206 14.2328 13.206 13.2896 13.003C17.206 10.8896 18.0179 7.04478 18.4119 5.4806C19.1284 7.96418 19.1761 10.0418 18.8537 11.7731Z","fill":"#345EE4"}})])
          )
        }
      }
    